import Dashboard from './lib/dashboard';
import ContentPopup from './lib/content-popup';


document.addEventListener('DOMContentLoaded', () => new Dashboard());
document.addEventListener('DOMContentLoaded', () => new ContentPopup());